(() => {
  // The script is included by several sections; only run it once
  if (window.opProductInit) return;
  window.opProductInit = true;

  // Always open a page at the top (unless a #section link was used)
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  if (!location.hash) window.scrollTo(0, 0);

  // Scroll reveal
  const revealTargets = document.querySelectorAll('.op-reveal');
  if (revealTargets.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    revealTargets.forEach((el) => io.observe(el));
  } else {
    revealTargets.forEach((el) => el.classList.add('is-in'));
  }

  // Cart icon pulses when something is added
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.product-form__submit, [data-sticky-add]')) return;
    setTimeout(() => {
      const bubble = document.querySelector('#cart-icon-bubble');
      if (!bubble) return;
      bubble.classList.remove('op-pulse');
      void bubble.offsetWidth;
      bubble.classList.add('op-pulse');
    }, 700);
  });

  // Gallery: scroll-snap slider with dots (mobile) and thumbnails (desktop)
  if (!customElements.get('op-gallery')) {
    customElements.define(
      'op-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.controls = this.querySelectorAll('[data-go]');
          if (!this.track) return;
          this.controls.forEach((btn) =>
            btn.addEventListener('click', () => this.go(Number(btn.dataset.go)))
          );
          this.thumbs = this.querySelector('[data-thumbs]');
          this.querySelector('[data-thumbs-prev]')?.addEventListener('click', () => this.scrollThumbs(-1));
          this.querySelector('[data-thumbs-next]')?.addEventListener('click', () => this.scrollThumbs(1));
          let ticking = false;
          this.track.addEventListener('scroll', () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              this.mark(Math.round(this.track.scrollLeft / this.track.clientWidth));
              ticking = false;
            });
          });
        }
        scrollThumbs(direction) {
          if (!this.thumbs) return;
          this.thumbs.scrollBy({ left: direction * this.thumbs.clientWidth * 0.8, behavior: 'smooth' });
        }
        go(index) {
          this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'smooth' });
          this.mark(index);
        }
        mark(index) {
          this.controls.forEach((btn) => {
            const active = Number(btn.dataset.go) === index;
            if (active) {
              btn.setAttribute('aria-current', 'true');
              if (this.thumbs && this.thumbs.contains(btn)) {
                // scroll only the thumbnail strip sideways, never the page
                const t = this.thumbs;
                const left = btn.offsetLeft - (t.clientWidth - btn.offsetWidth) / 2;
                t.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
              }
            } else {
              btn.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  // Bundle picker: sync the selected card with the form's variant id and price
  document.querySelectorAll('.op-product').forEach((root) => {
    const idInput = root.querySelector('.product-variant-id');
    const priceEl = root.querySelector('[data-price]');
    root.querySelectorAll('[data-bundle] input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        const qtyInput = root.querySelector('[data-qty-input]');
        if (radio.dataset.qty && qtyInput) qtyInput.value = radio.dataset.qty;
        else idInput.value = radio.value;
        const titleEl = root.querySelector('[data-selected-title]');
        if (titleEl) titleEl.textContent = radio.dataset.title;
        if (priceEl) {
          priceEl.innerHTML = '';
          const price = document.createElement('span');
          price.textContent = radio.dataset.price;
          priceEl.append(price);
          if (radio.dataset.compare) {
            const compare = document.createElement('s');
            compare.textContent = radio.dataset.compare;
            priceEl.append(compare);
          }
        }
        const index = [...root.querySelectorAll('[data-bundle] input[type="radio"]')].indexOf(radio) + 1;
        root.querySelectorAll('[data-gift]').forEach((gift) => {
          gift.classList.toggle('op-gift--locked', index < Number(gift.dataset.unlockAt || 1));
        });
        const stickyPrice = root.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        const stickyPkg = root.querySelector('[data-sticky-pkg]');
        if (stickyPkg) stickyPkg.textContent = radio.dataset.title;
        if (!radio.dataset.qty) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    // Visual option row ("Size:") and color swatches
    root.querySelectorAll('[data-optrow]').forEach((row) => {
      const valueEl = row.parentElement.querySelector('[data-optrow-value]');
      row.querySelectorAll('button').forEach((btn) =>
        btn.addEventListener('click', () => {
          row.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
          if (valueEl) valueEl.textContent = btn.textContent.trim();
        })
      );
    });
    root.querySelectorAll('[data-swatches]').forEach((group) => {
      const nameEl = group.querySelector('[data-swatch-name]');
      group.querySelectorAll('.op-swatch').forEach((btn) =>
        btn.addEventListener('click', () => {
          group.querySelectorAll('.op-swatch').forEach((b) => b.toggleAttribute('aria-current', b === btn));
          if (nameEl) nameEl.textContent = btn.dataset.name;
        })
      );
    });

    // Sticky add to cart: shows once the main button scrolls out of view
    const sticky = root.querySelector('[data-sticky]');
    const mainButton = root.querySelector('.product-form__submit');
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      }).observe(mainButton);
      sticky.querySelector('[data-sticky-add]').addEventListener('click', () => mainButton.click());
    }
  });

  // Numbered step tabs
  document.querySelectorAll('[data-op-steps]').forEach((root) => {
    const tabs = root.querySelectorAll('[role="tab"]');
    const panels = root.querySelectorAll('[role="tabpanel"]');
    const media = root.querySelectorAll('[data-step-media]');
    let timer;
    const select = (index) => {
      tabs.forEach((tab, i) => tab.setAttribute('aria-selected', String(i === index)));
      panels.forEach((panel, i) => (panel.hidden = i !== index));
      media.forEach((item, i) => (item.hidden = i !== index));
    };
    tabs.forEach((tab, i) =>
      tab.addEventListener('click', () => {
        clearInterval(timer);
        select(i);
      })
    );
    const delay = Number(root.dataset.autoplay || 0);
    if (delay > 0 && tabs.length > 1) {
      let current = 0;
      timer = setInterval(() => {
        current = (current + 1) % tabs.length;
        select(current);
      }, delay * 1000);
    }
  });

  // Frame scrubber: drag the image or the vertical step slider to move through frames
  document.querySelectorAll('[data-op-scrub]').forEach((root) => {
    const section = root.closest('[data-scrub-section]') || root;
    const stage = root.querySelector('[data-stage]');
    const frames = root.querySelectorAll('[data-frame]');
    const vstep = section.querySelector('[data-vstep]');
    if (!stage || frames.length === 0) return;

    const stops = vstep ? [...vstep.querySelectorAll('[data-step]')] : [];
    const dots = stops.map((s) => s.querySelector('[data-dot]'));
    const thumb = vstep?.querySelector('[data-thumb]');
    const track = vstep?.querySelector('[data-track]');
    const fill = vstep?.querySelector('[data-fill]');
    let progress = 0;

    const centers = () => {
      const base = vstep.getBoundingClientRect().top;
      return dots.map((d) => { const r = d.getBoundingClientRect(); return r.top - base + r.height / 2; });
    };
    // progress 0..1 maps piecewise onto the real dot centres, so the ring always lands on a dot
    const yFor = (p, c) => {
      const seg = p * (c.length - 1);
      const k = Math.min(Math.floor(seg), c.length - 2);
      return c[k] + (seg - k) * (c[k + 1] - c[k]);
    };
    let autoFill = false; // while auto-playing, the autoplay owns the line's height
    const layout = () => {
      if (!vstep || dots.length < 2) return;
      const c = centers();
      track.style.top = c[0] + 'px';
      track.style.height = c[c.length - 1] - c[0] + 'px';
      const y = yFor(progress, c);
      thumb.style.top = y - thumb.offsetHeight / 2 + 'px';
      if (!autoFill) fill.style.height = y - c[0] + 'px';
    };
    const render = (p) => {
      progress = Math.min(Math.max(p, 0), 1);
      const frame = Math.round(progress * (frames.length - 1));
      frames.forEach((f, i) => f.classList.toggle('is-active', i === frame));
      if (stops.length) {
        const active = Math.round(progress * (stops.length - 1));
        stops.forEach((s, i) => {
          s.classList.toggle('is-active', i === active);
          s.classList.toggle('is-passed', i < active);
        });
        thumb.setAttribute('aria-valuenow', String(active + 1));
      }
      layout();
    };

    if (vstep && dots.length > 1) {
      const fromPointer = (clientY) => {
        const c = centers();
        const y = clientY - vstep.getBoundingClientRect().top;
        if (y <= c[0]) return 0;
        for (let k = 0; k < c.length - 1; k++) {
          if (y <= c[k + 1]) return (k + (y - c[k]) / (c[k + 1] - c[k])) / (c.length - 1);
        }
        return 1;
      };
      let dragging = false;
      thumb.addEventListener('pointerdown', (e) => {
        dragging = true;
        thumb.setPointerCapture(e.pointerId);
        vstep.classList.add('is-dragging');
      });
      thumb.addEventListener('pointermove', (e) => dragging && render(fromPointer(e.clientY)));
      const end = () => {
        if (!dragging) return;
        dragging = false;
        vstep.classList.remove('is-dragging');
        render(Math.round(progress * (stops.length - 1)) / (stops.length - 1));
      };
      thumb.addEventListener('pointerup', end);
      thumb.addEventListener('pointercancel', end);
      track.parentElement.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-dot]');
        if (dot) render(dots.indexOf(dot) / (dots.length - 1));
      });
      thumb.addEventListener('keydown', (e) => {
        const step = Math.round(progress * (stops.length - 1));
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); render(Math.min(step + 1, stops.length - 1) / (stops.length - 1)); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); render(Math.max(step - 1, 0) / (stops.length - 1)); }
      });
      window.addEventListener('resize', layout);
      vstep.addEventListener('transitionend', layout);
    }

    // dragging across the image scrubs too
    let startX = null;
    let startP = 0;
    stage.addEventListener('pointerdown', (e) => { startX = e.clientX; startP = progress; stage.classList.add('is-touched'); });
    stage.addEventListener('pointermove', (e) => {
      if (startX === null) return;
      render(startP + (e.clientX - startX) / (stage.clientWidth * 0.9));
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((t) => stage.addEventListener(t, () => (startX = null)));
    render(0);
    requestAnimationFrame(layout);

    // Auto-play: the line grows toward the next dot during the wait; on arrival the dot fills,
    // the ring pulses in and out, and the image crossfades. Any drag/click pauses it for a while.
    const seconds = Number(section.dataset.autoplay || 0);
    const count = stops.length;
    if (seconds > 0 && count > 1 && vstep && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let step = 0;
      let running = false;
      let visible = false;
      let resumeAt = 0;
      let holdTimer = null;
      const radius = () => (dots[0]?.offsetHeight || 34) / 2;
      const pulse = () => {
        thumb.classList.remove('is-pulse');
        void thumb.offsetWidth;
        thumb.classList.add('is-pulse');
      };
      const dotY = (k) => {
        const c = centers();
        return c[k] - c[0];
      };
      // Step k becomes active the instant the line touches its circle.
      const arrive = (k) => {
        step = k;
        fill.style.transition = 'none';
        fill.style.height = dotY(k) + 'px';
        render(k / (count - 1));
        pulse();
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (!running) return;
          if (k < count - 1) {
            fill.style.transition = `height ${seconds}s linear`;
            fill.style.height = dotY(k + 1) - radius() + 'px';
          } else {
            holdTimer = setTimeout(() => {
              if (!running) return;
              fill.style.transition = 'height .7s cubic-bezier(.4,0,.2,1)';
              fill.style.height = '0px';
              holdTimer = setTimeout(() => running && arrive(0), 720);
            }, seconds * 1000);
          }
        }));
      };
      fill.addEventListener('transitionend', (e) => {
        if (!running || e.propertyName !== 'height' || step >= count - 1) return;
        if (fill.style.height === '0px') return;
        arrive(step + 1);
      });
      const start = () => {
        if (running) return;
        running = true;
        autoFill = true;
        root.classList.add('is-auto');
        vstep.classList.add('is-auto');
        arrive(Math.round(progress * (count - 1)));
      };
      const stop = () => {
        running = false;
        autoFill = false;
        clearTimeout(holdTimer);
        root.classList.remove('is-auto');
        vstep.classList.remove('is-auto');
        thumb.classList.remove('is-pulse');
        fill.style.transition = '';
        layout();
      };
      const pause = () => {
        stop();
        resumeAt = Date.now() + 8000;
        setTimeout(() => { if (visible && Date.now() >= resumeAt) start(); }, 8100);
      };
      [stage, vstep].forEach((el) => el?.addEventListener('pointerdown', pause));
      thumb?.addEventListener('keydown', pause);
      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (visible && Date.now() >= resumeAt) start();
        if (!visible && running) stop();
      }, { threshold: 0.35 }).observe(section);
    }
  });

  // Up close cards: plus button reveals the detail text
  document.querySelectorAll('[data-op-card-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const card = btn.closest('.op-card');
      const open = card.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  // Reviews: load more
  document.querySelectorAll('[data-op-reviews-more]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const list = document.getElementById(btn.getAttribute('aria-controls'));
      const hidden = [...list.querySelectorAll('.op-review[hidden]')];
      hidden.slice(0, 5).forEach((item) => (item.hidden = false));
      if (hidden.length <= 5) btn.remove();
    });
  });

  // Reviews: expand long review text
  document.querySelectorAll('[data-op-review-more]').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.previousElementSibling.classList.remove('is-clamped');
      btn.remove();
    });
  });

  // Review carousel: arrows step one card at a time; counter shows the first visible card
  document.querySelectorAll('[data-op-rc]').forEach((root) => {
    const track = root.querySelector('[data-track]');
    const slides = [...root.querySelectorAll('[data-slide]')];
    const current = root.querySelector('[data-current]');
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    if (!track || !slides.length) return;
    const cardW = () => slides[0].getBoundingClientRect().width;
    const index = () => Math.round(track.scrollLeft / cardW());
    const perView = () => Math.max(1, Math.round(track.clientWidth / cardW()));
    const update = () => {
      const i = index();
      const last = Math.max(0, slides.length - perView());
      if (current) current.textContent = perView() > 1 ? `${i + 1}–${Math.min(i + perView(), slides.length)}` : String(i + 1);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= last;
    };
    const go = (d) => {
      const last = Math.max(0, slides.length - perView());
      const i = Math.min(Math.max(index() + d, 0), last);
      track.scrollTo({ left: i * cardW(), behavior: 'smooth' });
    };
    prev?.addEventListener('click', () => go(-1));
    next?.addEventListener('click', () => go(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // Gallery lightbox: click a slide to open full screen, arrows / swipe / keys to browse
  document.querySelectorAll('[data-lightbox]').forEach((lb) => {
    const gallery = lb.closest('op-gallery');
    const imgs = [...lb.querySelectorAll('[data-lb-img]')];
    const slides = [...gallery.querySelectorAll('.op-gallery__slide')];
    const counter = lb.querySelector('[data-lb-current]');
    if (!imgs.length) return;
    document.body.append(lb);
    let i = 0;
    let lastFocus = null;
    const show = (n) => {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach((img, k) => {
        if (k === i && !img.src) img.src = img.dataset.src;
        img.hidden = k !== i;
      });
      const nextImg = imgs[(i + 1) % imgs.length];
      if (!nextImg.src) nextImg.src = nextImg.dataset.src;
      if (counter) counter.textContent = i + 1;
    };
    const open = (n) => {
      lastFocus = document.activeElement;
      show(n);
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      lb.querySelector('[data-lb-close]').focus();
    };
    const close = () => {
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      lastFocus?.focus();
    };
    let downX = null;
    slides.forEach((slide, k) => {
      slide.addEventListener('pointerdown', (e) => (downX = e.clientX));
      slide.addEventListener('click', (e) => {
        if (downX !== null && Math.abs(e.clientX - downX) > 8) return; // that was a swipe
        open(k);
      });
    });
    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    lb.querySelector('[data-lb-prev]').addEventListener('click', () => show(i - 1));
    lb.querySelector('[data-lb-next]').addEventListener('click', () => show(i + 1));
    lb.addEventListener('click', (e) => { if (e.target === lb || e.target.matches('[data-lb-stage]')) close(); });
    document.addEventListener('keydown', (e) => {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(i - 1);
      if (e.key === 'ArrowRight') show(i + 1);
    });
    let startX = null;
    lb.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
    lb.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) show(i + (dx < 0 ? 1 : -1));
      startX = null;
    });
  });

  // Announcement bar rotation
  document.querySelectorAll('[data-op-announce]').forEach((root) => {
    const msgs = root.querySelectorAll('.op-announce__msg');
    if (msgs.length < 2) return;
    let current = [...msgs].findIndex((m) => m.classList.contains('is-active'));
    const show = (i) => {
      current = (i + msgs.length) % msgs.length;
      msgs.forEach((m, idx) => m.classList.toggle('is-active', idx === current));
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => show(current - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => show(current + 1));
    setInterval(() => show(current + 1), 5000);
  });

  // Header menu drawer
  document.querySelectorAll('[data-op-drawer-open]').forEach((btn) => {
    const drawer = document.getElementById(btn.getAttribute('aria-controls'));
    if (!drawer) return;
    const close = () => {
      drawer.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    };
    btn.addEventListener('click', () => {
      drawer.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      drawer.querySelector('[data-op-drawer-close]').focus();
    });
    drawer.querySelectorAll('[data-op-drawer-close]').forEach((el) => el.addEventListener('click', close));
    drawer.addEventListener('keydown', (e) => e.key === 'Escape' && close());
  });

  // Background video play / pause
  document.querySelectorAll('[data-op-video]').forEach((root) => {
    const video = root.querySelector('video');
    const btn = root.querySelector('[data-op-video-toggle]');
    if (!video || !btn) return;
    btn.addEventListener('click', () => {
      if (video.paused) video.play();
      else video.pause();
    });
    const sync = () => {
      btn.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      btn.querySelector('[data-icon-pause]').style.display = video.paused ? 'none' : '';
      btn.querySelector('[data-icon-play]').style.display = video.paused ? '' : 'none';
    };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  });

  // Desktop: the Product details section sits in the right column under the buy box.
  // Mobile keeps it in its own place in the page flow.
  const sideSlot = document.querySelector('[data-side-details]');
  const details = document.querySelector('.op-product-details');
  if (sideSlot && details) {
    const home = document.createComment('op-product-details');
    details.before(home);
    const desktop = window.matchMedia('(min-width: 990px)');
    // Desktop: the value cards fill the space under the image grid instead.
    const valuesSlot = document.querySelector('[data-gallery-values]');
    const values = details.querySelector('.op-values');
    const valuesHome = values && document.createComment('op-values');
    if (values) values.before(valuesHome);
    const place = () => {
      if (desktop.matches) {
        sideSlot.append(details);
        if (values && valuesSlot) valuesSlot.append(values);
      } else {
        home.after(details);
        if (values) valuesHome.after(values);
      }
    };
    place();
    desktop.addEventListener('change', place);
  }
})();
